import { Component, OnInit, OnDestroy } from '@angular/core';
import { ResourceService } from 'src/app/services/resource.service';
import Resource from 'src/app/interfaces/Resource';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { UploadService } from 'src/app/services/upload.service';
import { LoadingService } from 'src/app/services/loading.service';
import { UrlService } from 'src/app/services/url.service';

@Component({
  selector: 'app-edit-resource',
  templateUrl: './edit-resource.component.html',
  styleUrls: ['./edit-resource.component.scss'],
})
export class EditResourceComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  currentUser;
  resource;
  attachmentFile: File = null;
  attachmentPreviewURL;
  quillModules = {
    toolbar: [['link', 'bold', 'italic', 'underline', 'strike', 'blockquote', { list: 'ordered' }, { list: 'bullet' }]],
  };
  tags = {
    standard: [
      'technology',
      'environmental-impacts',
      'governance',
      'markets-finance',
      'funding',
      'cdr-community',
      'social-licensing',
    ],
    approaches: ['microalgae', 'blue-carbon', 'macroalgal','alkalinity', 'co2-removal', 'storage', 'other'],
  };
  coauthorsFocus = [];
  urlError = '';
  openAccessCheckbox = false;

  constructor(
    private resourceService: ResourceService,
    private userService: UserService,
    private router: Router,
    private uploadService: UploadService,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private urlService: UrlService
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;
        }
      })
    );
    this.route.queryParams.subscribe((params) => {
      if (params['id']) {
        this.resourceService.getResource(params['id']).then((r) => {
          this.resource = r;
          if (this.resource.attachment) {
            this.openAccessCheckbox = true;
          }
        });
      }
    });
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  addCoAuthor() {
    this.resource.coauthors.push('');
    this.coauthorsFocus.push(false);
  }
  save(): void {
    this.loadingService.startLoading();
    this.resource.description = this.urlService.processContent(this.resource.description);
    if (this.attachmentFile) {
      this.uploadService.uploadFile(this.attachmentFile).then((downloadUrl) => {
        this.resource.attachment = {
          name: this.attachmentFile.name,
          url: downloadUrl,
          size: this.attachmentFile.size,
        };
        this.updateResource();
      });
    } else {
      this.updateResource();
    }
  }
  updateResource(): void {
    this.resourceService.updateResource(this.resource.id, this.resource).then(
      () => {
        this.loadingService.stopLoading();
        this.router.navigate(['/resources/' + this.resource.id]);
      },
      (err) => {
        console.error(err);
      }
    );
  }

  upload(event): void {
    if (event.target && event.target.files.length > 0) {
      var reader = new FileReader();
      var t = this;
      reader.onload = function (e) {
        t.attachmentPreviewURL = reader.result;
      };
      if (event.target.files[0].name.endsWith('.pdf')) {
        let $img: any = document.querySelector('input[type="file"]');
        reader.readAsArrayBuffer($img.files[0]);
      }
      if (!event.target.files[0].name.endsWith('.pdf')) {
        reader.readAsDataURL(event.target.files[0]); // convert to base64 string
      }
      this.attachmentFile = event.target.files[0];
      this.openAccessCheckbox = false;
    }
  }

  toggleApproach(a): void {
    if (this.resource.approaches.indexOf(a) === -1) {
      this.resource.approaches.push(a);
    } else {
      this.resource.approaches.splice(this.resource.approaches.indexOf(a), 1);
    }
  }
  toggleTag(t): void {
    if (this.resource.tags.indexOf(t) === -1) {
      this.resource.tags.push(t);
    } else {
      this.resource.tags.splice(this.resource.approaches.indexOf(t), 1);
    }
  }

  getResourceMeta(url, inputObj) {
    inputObj.isFocused = false;
    if (this.urlService.validURL(url)) {
      this.resourceService.getResourceMeta(url).subscribe(
        (res) => {
          this.urlError = '';
          this.resource.resourceMeta = res;
        },
        (err) => {
          console.error(err);
          this.urlError = 'There was an error finding this URL.';
        }
      );
    } else {
      this.urlError = 'Please provide a valid URL.';
    }
  }
  clearError() {
    this.urlError = '';
  }

  removeFile() {
    if (this.attachmentFile) {
      this.attachmentFile = null;
    }
    if (this.resource.attachment) {
      this.resource.attachment = null;
    }
  }

  preventBlur(index) {
    return index;
  }
}
